export default __webpack_public_path__ + "static/media/robot.53c219e0.png";